/**
 * Dream House CLT - Theme JavaScript
 * Mobile-first, high-converting boutique theme
 */

(function() {
  'use strict';

  // === Mobile Navigation ===
  var mobileNav = {
    init: function() {
      var toggle = document.querySelector('.menu-toggle');
      var nav = document.querySelector('.mobile-nav');
      var overlay = document.querySelector('.mobile-nav__overlay');
      var close = document.querySelector('.mobile-nav__close');

      if (!toggle || !nav) return;

      toggle.addEventListener('click', function() {
        nav.classList.add('is-open');
        if (overlay) overlay.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
      });

      var closeNav = function() {
        nav.classList.remove('is-open');
        if (overlay) overlay.classList.remove('is-visible');
        document.body.style.overflow = '';
      };

      if (close) close.addEventListener('click', closeNav);
      if (overlay) overlay.addEventListener('click', closeNav);
    }
  };

  // === Cart Drawer ===
  var cartDrawer = {
    init: function() {
      var drawer = document.querySelector('.cart-drawer');
      var openBtns = document.querySelectorAll('[data-cart-toggle]');
      var closeBtn = document.querySelector('.cart-drawer__close');
      var overlay = document.querySelector('.cart-drawer__overlay');

      if (!drawer) return;

      openBtns.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          drawer.classList.add('is-open');
          if (overlay) overlay.classList.add('is-visible');
          document.body.style.overflow = 'hidden';
        });
      });

      var closeDrawer = function() {
        drawer.classList.remove('is-open');
        if (overlay) overlay.classList.remove('is-visible');
        document.body.style.overflow = '';
      };

      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
      if (overlay) overlay.addEventListener('click', closeDrawer);
    },

    open: function() {
      var drawer = document.querySelector('.cart-drawer');
      var overlay = document.querySelector('.cart-drawer__overlay');
      if (drawer) {
        drawer.classList.add('is-open');
        if (overlay) overlay.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
      }
    },

    refresh: function() {
      // Fetch the cart page and extract the cart drawer HTML
      fetch('/?sections=header')
        .then(function(response) { return response.json(); })
        .then(function(data) {
          if (data.header) {
            var temp = document.createElement('div');
            temp.innerHTML = data.header;

            // Update cart drawer items
            var newItems = temp.querySelector('.cart-drawer__items');
            var currentItems = document.querySelector('.cart-drawer__items');
            if (newItems && currentItems) {
              currentItems.innerHTML = newItems.innerHTML;
            }

            // Update cart drawer footer
            var newFooter = temp.querySelector('.cart-drawer__footer');
            var currentFooter = document.querySelector('.cart-drawer__footer');
            var drawer = document.querySelector('.cart-drawer');
            if (newFooter && currentFooter) {
              currentFooter.innerHTML = newFooter.innerHTML;
            } else if (newFooter && !currentFooter && drawer) {
              drawer.insertAdjacentHTML('beforeend', newFooter.outerHTML);
            } else if (!newFooter && currentFooter) {
              currentFooter.remove();
            }

            // Update cart drawer title
            var newTitle = temp.querySelector('.cart-drawer__title');
            var currentTitle = document.querySelector('.cart-drawer__title');
            if (newTitle && currentTitle) {
              currentTitle.textContent = newTitle.textContent;
            }

            // Update cart count badges
            var newCount = temp.querySelector('.cart-count');
            if (newCount) {
              document.querySelectorAll('.cart-count').forEach(function(el) {
                el.textContent = newCount.textContent;
                el.style.display = newCount.style.display;
              });
            }
          }
        })
        .catch(function(err) {
          // Fallback: just update cart count
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              document.querySelectorAll('.cart-count').forEach(function(el) {
                el.textContent = cart.item_count;
                el.style.display = cart.item_count > 0 ? 'flex' : 'none';
              });
            });
        });
    }
  };

  // === Product Image Gallery ===
  var productGallery = {
    init: function() {
      var thumbs = document.querySelectorAll('.product-gallery__thumb');
      var mainImage = document.querySelector('.product-gallery__main img');

      if (!thumbs.length || !mainImage) return;

      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          thumbs.forEach(function(t) { t.classList.remove('active'); });
          this.classList.add('active');
          var img = this.querySelector('img');
          if (img) {
            mainImage.src = img.dataset.fullsize || img.src;
          }
        });
      });
    }
  };

  // === Variant Selector ===
  var variantSelector = {
    init: function() {
      var productSelect = document.getElementById('product-select');
      if (!productSelect) return;

      var buttons = document.querySelectorAll('.variant-btn');
      if (!buttons.length) return;

      buttons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          // Update visual state within the same option group
          var group = this.closest('.product-form__variants');
          if (group) {
            group.querySelectorAll('.variant-btn').forEach(function(b) {
              b.classList.remove('selected');
            });
          }
          this.classList.add('selected');

          // Build selected options array
          var selectedOptions = [];
          document.querySelectorAll('.product-form__variants').forEach(function(optGroup) {
            var selected = optGroup.querySelector('.variant-btn.selected');
            if (selected) {
              selectedOptions.push(selected.dataset.value);
            }
          });

          // Match selected options to variant in the hidden select
          var options = productSelect.querySelectorAll('option');
          for (var i = 0; i < options.length; i++) {
            var optionText = options[i].textContent.trim();
            // Shopify variant titles are formatted as "Option1 / Option2 / Option3"
            var optionParts = optionText.split(' - ')[0].trim().split(' / ');
            var match = true;
            for (var j = 0; j < selectedOptions.length; j++) {
              if (optionParts[j] && optionParts[j].trim() !== selectedOptions[j]) {
                match = false;
                break;
              }
            }
            if (match) {
              productSelect.value = options[i].value;

              // Update price display
              variantSelector.updatePrice(options[i]);

              // Update availability
              variantSelector.updateAvailability(options[i]);
              break;
            }
          }
        });
      });
    },

    updatePrice: function(option) {
      // Price is embedded in option text as "Title - $XX.XX"
      var priceContainer = document.querySelector('.product-info__price');
      var addBtn = document.querySelector('.product-form__add-to-cart .btn');
      if (!priceContainer || !addBtn) return;

      var text = option.textContent.trim();
      var priceMatch = text.match(/\$[\d,.]+/);
      if (priceMatch && addBtn && !option.disabled) {
        addBtn.innerHTML = 'Add to Bag &mdash; ' + priceMatch[0];
      }
    },

    updateAvailability: function(option) {
      var addBtn = document.querySelector('.product-form__add-to-cart .btn');
      if (!addBtn) return;

      if (option.disabled) {
        addBtn.disabled = true;
        addBtn.textContent = 'Sold Out';
      } else {
        addBtn.disabled = false;
      }
    }
  };

  // === Scroll Animations ===
  var scrollAnimations = {
    init: function() {
      if (!('IntersectionObserver' in window)) {
        // Fallback for older browsers: show everything
        document.querySelectorAll('[data-animate]').forEach(function(el) {
          el.style.opacity = '1';
        });
        return;
      }

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      document.querySelectorAll('[data-animate]').forEach(function(el) {
        el.style.opacity = '0';
        observer.observe(el);
      });
    }
  };

  // === Sticky Header ===
  var stickyHeader = {
    init: function() {
      var header = document.querySelector('.site-header');
      if (!header) return;

      var lastScroll = 0;
      var ticking = false;

      window.addEventListener('scroll', function() {
        if (!ticking) {
          window.requestAnimationFrame(function() {
            var currentScroll = window.pageYOffset;

            if (currentScroll > 100) {
              header.classList.add('is-scrolled');
            } else {
              header.classList.remove('is-scrolled');
            }

            if (currentScroll > lastScroll && currentScroll > 200) {
              header.style.transform = 'translateY(-100%)';
            } else {
              header.style.transform = 'translateY(0)';
            }

            lastScroll = currentScroll;
            ticking = false;
          });
          ticking = true;
        }
      });
    }
  };

  // === Quick Add to Cart ===
  var quickAdd = {
    init: function() {
      document.addEventListener('click', function(e) {
        var btn = e.target.closest('.quick-add-btn');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        var variantId = btn.dataset.variantId;
        if (!variantId) return;

        var originalText = btn.textContent;
        btn.classList.add('is-loading');
        btn.textContent = 'Adding...';
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Add to cart failed');
          }
          return response.json();
        })
        .then(function() {
          btn.textContent = 'Added!';
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');

          // Refresh cart drawer and open it
          cartDrawer.refresh();
          cartDrawer.open();

          setTimeout(function() {
            btn.textContent = originalText;
            btn.classList.remove('is-added');
            btn.disabled = false;
          }, 2000);
        })
        .catch(function() {
          btn.textContent = originalText;
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
      });
    }
  };

  // === Product Form AJAX Submit ===
  var productForm = {
    init: function() {
      var form = document.querySelector('form[action="/cart/add"]');
      if (!form) return;

      form.addEventListener('submit', function(e) {
        e.preventDefault();

        var submitBtn = form.querySelector('[type="submit"]');
        if (!submitBtn || submitBtn.disabled) return;

        var originalText = submitBtn.innerHTML;
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';

        var formData = new FormData(form);
        var data = {};
        formData.forEach(function(value, key) {
          data[key] = value;
        });

        // Ensure id is a number
        if (data.id) {
          data.id = parseInt(data.id, 10);
        }
        data.quantity = data.quantity ? parseInt(data.quantity, 10) : 1;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: data.id, quantity: data.quantity })
        })
        .then(function(response) {
          if (!response.ok) {
            throw new Error('Add to cart failed');
          }
          return response.json();
        })
        .then(function() {
          submitBtn.innerHTML = 'Added to Bag!';

          // Refresh cart drawer and open it
          cartDrawer.refresh();
          cartDrawer.open();

          setTimeout(function() {
            submitBtn.innerHTML = originalText;
            submitBtn.disabled = false;
          }, 2500);
        })
        .catch(function() {
          submitBtn.innerHTML = originalText;
          submitBtn.disabled = false;
        });
      });
    }
  };

  // === Newsletter Form ===
  var newsletter = {
    init: function() {
      var form = document.getElementById('newsletter-form');
      if (!form) return;

      form.addEventListener('submit', function() {
        var btn = form.querySelector('button[type="submit"]');
        if (btn) {
          btn.textContent = 'Subscribing...';
          btn.disabled = true;
        }
      });
    }
  };

  // === Product Card Hover (Touch Devices) ===
  var touchHover = {
    init: function() {
      if ('ontouchstart' in window) {
        document.querySelectorAll('.product-card').forEach(function(card) {
          card.addEventListener('touchstart', function() {
            this.classList.add('is-touched');
          }, { passive: true });
          card.addEventListener('touchend', function() {
            var self = this;
            setTimeout(function() {
              self.classList.remove('is-touched');
            }, 300);
          });
        });
      }
    }
  };

  // === Initialize All Modules ===
  document.addEventListener('DOMContentLoaded', function() {
    mobileNav.init();
    cartDrawer.init();
    productGallery.init();
    variantSelector.init();
    scrollAnimations.init();
    stickyHeader.init();
    quickAdd.init();
    productForm.init();
    newsletter.init();
    touchHover.init();
  });

})();
